<!--
  Created 21.05.2023
  Destinations page header component
-->
<template>
  <header class="flex items-end justify-between border-b border-gray-200 p-2 pb-0 md:p-4 md:pb-0">
    <!-- Title -->
    <div class="pb-2 md:pb-3">
      <p
        v-if="Object.keys(destination).length > 0"
        class="text-xs text-gray-700">
        <Link
          :href="route('destinations')"
          class="hover:text-purple-800 hover:underline">
          Destinations
        </Link><span class="text-gray-400">→</span> {{ destination.area }} <span class="text-gray-400">→</span>
      </p>
      <h1 class="text-3xl font-bold tracking-tight text-gray-900">
        {{ destination.name ?? heading }}
      </h1>
    </div>
    <!-- Navigation destination -->
    <nav
      v-if="navigationTabs.length > 0"
      class="-ml-6 flex">
      <!-- Mobile navigation -->
      <div class="lg:hidden">
        <label
          for="selected-tab"
          class="sr-only">
          Select a tab
        </label>
        <select
          id="selected-tab"
          name="selected-tab"
          class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm">
          <option
            v-for="tab in navigationTabs"
            :key="tab.name"
            :selected="(route().current(tab.route))">
            {{ tab.name }}
          </option>
        </select>
      </div>
      <!-- Desktop navigation -->
      <div class="hidden lg:block">
        <div class="-mb-px flex space-x-8">
          <Link
            v-for="tab in navigationTabs"
            :key="tab.name"
            :href="tab.route ? route(tab.route, {destination: destination}) : tab.href"
            :class="[route().current(tab.route) ?
              'border-purple-600 text-purple-700' :
              'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium']">
            {{ tab.name }}
          </Link>
        </div>
      </div>
    </nav>
    <!-- Top-right button -->
    <div
      v-if="$slots.button"
      class="flex flex-row items-center space-x-2 pb-2 md:pb-4">
      <slot name="button" />
    </div>
    <div
      v-else-if="button"
      class="flex flex-row items-center space-x-2 pb-2 md:pb-4">
      <Link :href="route(button.route)">
        <button
          type="button"
          class="inline-flex items-center rounded-md border border-transparent bg-purple-800 px-4 py-2 text-sm
                font-medium text-white shadow-sm hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-800 focus:ring-offset-2">
          {{ button.name }}
        </button>
      </Link>
    </div>
    <div
      v-else
      class="w-48" />
  </header>
</template>

<script setup>
/* external imports */
import { Link } from '@inertiajs/vue3';

defineProps({
  destination: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  heading: {
    type: String,
    required: false,
    default: 'Destinations',
  },
  navigationTabs: {
    type: [Array, Boolean],
    required: false,
    default: () => ([
      {
        name: 'Overview',
        route: 'destinations.show',
        destination: {
          type: Object, required: true,
        },
      },
      {
        name: 'Map & Entities',
        route: 'destinations.map',
        destination: {
          type: Object, required: true,
        },
      },
      {
        name: 'Proposals',
        route: 'destinations.proposals',
        destination: {
          type: Object, required: true,
        },
      },
    ]),
  },
  button: {
    type: [Object, Boolean],
    required: false,
    default: () => ({
      name: 'New proposal',
      route: 'proposals.create',
    }),
  },
});
</script>
